export default {
  email: 'a180344@yahoo.com',
  avatarUrl: 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/05.png'
}
